/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import Payment from '../../PaymentGateway/Payment';
import { showToast } from '../../showTost';
import { useTranslation } from 'react-i18next';
const Wallet = () => {

    const { t } = useTranslation();
    const { ApiBasUrl, paymentRes, setPaymentRes } = useContext(MyContext);

    const [mywallet, setMyWallet] = useState("");
    const [transactionlist, seyTransactionList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isshow, setIsShow] = useState(false);
    const [bookinglod, setBookingLod] = useState(false);


    const Currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        HandleFechData();

        const PaymentResponse = sessionStorage.getItem("Paymentstatus");
        if (!PaymentResponse) return;
        if (PaymentResponse === "PaymentDone") {
            setPaymentRes("PaymentDone");
        } else {
            setPaymentRes("PaymentFaild");
        }

    }, []);

    const HandleFechData = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${ApiBasUrl}/wallet_report.php`, { uid: Userid })
                .then((res) => {
                    setMyWallet(res.data.wallet);
                    seyTransactionList(res.data.Walletitem);
                    secureLocalStorage.setItem("mywallet", res.data.wallet);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("wallet_report.php", error);
                });
        }
    };

    useEffect(() => {
        if (!paymentRes) return;
        if (paymentRes === "PaymentDone") {
            setBookingLod(true);
            HandleTopUp();
            setIsShow(false);
        } else {
            showToast({ title: t("Payment Faild !!"), id: "error" });
            setIsShow(false);
            setPaymentRes("");
            sessionStorage.removeItem("Paymentstatus");
        }
    }, [paymentRes]);

    const HandleTopUp = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        const Amount = secureLocalStorage.getItem("Amount");

        if (Userid && Amount) {
            axios.post(`${ApiBasUrl}/wallet_up.php`, { uid: Userid, wallet: Amount })
                .then((res) => {
                    setBookingLod(false);
                    showToast({ title: res.data.ResponseMsg, id: "success" });
                    setMyWallet(res.data.wallet);
                    secureLocalStorage.removeItem("Amount");
                    sessionStorage.removeItem("Paymentstatus");
                    sessionStorage.removeItem("transactionid");
                    HandleFechData();
                    setPaymentRes("");
                })
                .catch((error) => {
                    console.error("wallet_up.php", error);
                });
        }
    };

    return (
        <div className='wallet_page -mt-[15px]'>
            {loading
                ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                    <div className="loader2"></div>
                </div>
                : <div className="width_container">

                    <div className="bg-[#F1F2F4] sticky top-[70px] left-0 right-0 py-[20px]">
                        <div className="bg-white rounded-[15px] py-[20px] px-[30px] max-_430_:p-[10px]">
                            <div className="flex items-center gap-[10px] justify-between">
                                <div className="">
                                    <h1 className='font-[500] text-[16px]'>{t("Total Balance")}</h1>
                                    <span className='font-bold text-[20px]'>{Currency}{mywallet}</span>
                                </div>
                                <button onClick={() => setIsShow(true)} className='topup_button'>
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.5301 10.5301C19.3841 10.6761 19.192 10.7501 19 10.7501C18.808 10.7501 18.616 10.6771 18.47 10.5301L12.75 4.81017V21.0001C12.75 21.4141 12.414 21.7501 12 21.7501C11.586 21.7501 11.25 21.4141 11.25 21.0001V4.81115L5.53005 10.5311C5.23705 10.8241 4.76202 10.8241 4.46902 10.5311C4.17602 10.2381 4.17602 9.76309 4.46902 9.47009L11.469 2.47009C11.538 2.40109 11.6209 2.34622 11.7129 2.30822C11.8959 2.23222 12.1029 2.23222 12.2859 2.30822C12.3779 2.34622 12.4611 2.40109 12.5301 2.47009L19.5301 9.47009C19.8231 9.76309 19.8231 10.2371 19.5301 10.5301Z" fill="#25314C" />
                                    </svg>
                                    <span>{t("Top Up")}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-[15px] py-[20px] px-[30px] max-_430_:p-[10px]">
                        <h1 className='font-[500] text-[18px]'>{t("Transaction")}</h1>

                        <div className="mt-[10px]">
                            {transactionlist.length >= 1
                                ? transactionlist.map((item, index) => {
                                    return <div key={index} className="border-[2px] rounded-[20px] mt-[10px] py-[15px] px-[40px] max-_430_:px-[10px]">
                                        <div className="flex items-center gap-[10px] justify-between">
                                            <div className="flex items-center gap-[20px] max-_430_:gap-[10px]">
                                                {item.status === "Credit" ?
                                                    <div className="text-green-500 bg-green-200 p-[10px] rounded-full">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11.9402 2.20983L9.5302 7.81983H7.1202C6.7202 7.81983 6.3302 7.84983 5.9502 7.92983L6.9502 5.52983L6.9902 5.43983L7.0502 5.27983C7.0802 5.20983 7.1002 5.14983 7.1302 5.09983C8.2902 2.40983 9.5902 1.56983 11.9402 2.20983Z" fill="currentColor" />
                                                            <path d="M18.7301 8.09002L18.7101 8.08002C18.1101 7.91002 17.5001 7.82002 16.8801 7.82002H10.6201L12.8701 2.59002L12.9001 2.52002C13.0401 2.57002 13.1901 2.64002 13.3401 2.69002L15.5501 3.62002C16.7801 4.13002 17.6401 4.66002 18.1701 5.30002C18.2601 5.42002 18.3401 5.53002 18.4201 5.66002C18.5101 5.80002 18.5801 5.94002 18.6201 6.09002C18.6601 6.18002 18.6901 6.26002 18.7101 6.35002C18.8601 6.86002 18.8701 7.44002 18.7301 8.09002Z" fill="currentColor" />
                                                            <path d="M18.2902 9.51982C17.8402 9.38982 17.3702 9.31982 16.8802 9.31982H7.12023C6.44023 9.31982 5.80023 9.44982 5.20023 9.70982C3.46023 10.4598 2.24023 12.1898 2.24023 14.1998V16.1498C2.24023 16.3898 2.26023 16.6198 2.29023 16.8598C2.51023 20.0398 4.21023 21.7398 7.39023 21.9498C7.62023 21.9798 7.85023 21.9998 8.10023 21.9998H15.9002C19.6002 21.9998 21.5502 20.2398 21.7402 16.7398C21.7502 16.5498 21.7602 16.3498 21.7602 16.1498V14.1998C21.7602 11.9898 20.2902 10.1298 18.2902 9.51982ZM14.5002 16.1898H12.7502V17.9998C12.7502 18.4098 12.4102 18.7498 12.0002 18.7498C11.5902 18.7498 11.2502 18.4098 11.2502 17.9998V16.1898H9.50023C9.09023 16.1898 8.75023 15.8598 8.75023 15.4398C8.75023 15.0298 9.09023 14.6898 9.50023 14.6898H11.2502V12.9998C11.2502 12.5898 11.5902 12.2498 12.0002 12.2498C12.4102 12.2498 12.7502 12.5898 12.7502 12.9998V14.6898H14.5002C14.9102 14.6898 15.2502 15.0298 15.2502 15.4398C15.2502 15.8598 14.9102 16.1898 14.5002 16.1898Z" fill="currentColor" />
                                                        </svg>
                                                    </div>
                                                    : <div className="text-[red] bg-red-200 p-[10px] rounded-full">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11.9402 2.20983L9.5302 7.81983H7.1202C6.7202 7.81983 6.3302 7.84983 5.9502 7.92983L6.9502 5.52983L6.9902 5.43983L7.0502 5.27983C7.0802 5.20983 7.1002 5.14983 7.1302 5.09983C8.2902 2.40983 9.5902 1.56983 11.9402 2.20983Z" fill="currentColor" />
                                                            <path d="M18.7301 8.09002L18.7101 8.08002C18.1101 7.91002 17.5001 7.82002 16.8801 7.82002H10.6201L12.8701 2.59002L12.9001 2.52002C13.0401 2.57002 13.1901 2.64002 13.3401 2.69002L15.5501 3.62002C16.7801 4.13002 17.6401 4.66002 18.1701 5.30002C18.2601 5.42002 18.3401 5.53002 18.4201 5.66002C18.5101 5.80002 18.5801 5.94002 18.6201 6.09002C18.6601 6.18002 18.6901 6.26002 18.7101 6.35002C18.8601 6.86002 18.8701 7.44002 18.7301 8.09002Z" fill="currentColor" />
                                                            <path d="M18.2902 9.51982C17.8402 9.38982 17.3702 9.31982 16.8802 9.31982H7.12023C6.44023 9.31982 5.80023 9.44982 5.20023 9.70982C3.46023 10.4598 2.24023 12.1898 2.24023 14.1998V16.1498C2.24023 16.3898 2.26023 16.6198 2.29023 16.8598C2.51023 20.0398 4.21023 21.7398 7.39023 21.9498C7.62023 21.9798 7.85023 21.9998 8.10023 21.9998H15.9002C19.6002 21.9998 21.5502 20.2398 21.7402 16.7398C21.7502 16.5498 21.7602 16.3498 21.7602 16.1498V14.1998C21.7602 11.9898 20.2902 10.1298 18.2902 9.51982ZM14.5002 16.7498H9.50023C9.09023 16.7498 8.75023 16.4098 8.75023 15.9998C8.75023 15.5898 9.09023 15.2498 9.50023 15.2498H14.5002C14.9102 15.2498 15.2502 15.5898 15.2502 15.9998C15.2502 16.4098 14.9102 16.7498 14.5002 16.7498Z" fill="currentColor" />
                                                        </svg>
                                                    </div>
                                                }
                                                < div className="leading-[19px]">
                                                    <h1 className='font-[500] text-[18px] max-_430_:text-[15px]'>{item.message}</h1>
                                                    <span className='text-gray-500'>{item.status}</span>
                                                </div>
                                            </div>
                                            <p className={`font-[500] whitespace-nowrap ${item.status === "Credit" ? "text-green-500" : "text-[red]"}`}>{item.status === "Credit" ? "+" : "-"} {Currency}{item.amt}</p>
                                        </div>
                                    </div>
                                })
                                : <div className="w-full h-[200px] flex items-center justify-center">
                                    <h1 className='font-bold text-gray-500 text-[17px]'>{t("No Any Transaction History !!")}</h1>
                                </div>}
                        </div>
                    </div>
                </div>}

            {
                isshow && <div onClick={() => setIsShow(false)} className="bottem_sheet items-end">
                    <div onClick={(e) => e.stopPropagation()} className="bottem_box py-[10px] px-[15px]">
                        <Payment Index={0} />
                    </div>
                </div>
            }

            {bookinglod && <div className="h-[100vh] w-full bg-[#00000067] fixed top-0 left-0 z-[999] flex items-center justify-center">
                <div style={{ width: "33px", height: "33px" }} className="loader"></div>
            </div>}

        </div >
    )
}

export default Wallet;
/* jshint ignore:end */